import { render, staticRenderFns } from "./ResizePanel.vue?vue&type=template&id=50afc6d8&"
import script from "./ResizePanel.vue?vue&type=script&lang=js&"
export * from "./ResizePanel.vue?vue&type=script&lang=js&"
import style0 from "./ResizePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports